import { StyleSheet } from 'react-native';

import { tokens } from '@fhs/ui';
import { type IRewardFragment } from '@fhs-legacy/frontend/src/generated/graphql-gateway';

export interface IRewardBarComponentProps {
  cartId: string;
  loyaltyRewardAvailable: IRewardFragment;
}

export const styles = StyleSheet.create({
  spacer: {
    width: 1,
    height: '30%',
    backgroundColor: tokens.colors.$blackOpacity10,
    marginHorizontal: 16,
  },
  active: {
    backgroundColor: 'rgba(56, 127, 73, 0.04)',
  },
  redeemContainer: {
    width: '100%',
    paddingHorizontal: 16,
    marginTop: 16,
    height: 52,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: tokens.colors.$blackOpacity04,
  },
  pointsButton: {
    borderColor: tokens.colors.$black10,
    padding: 8,
  },
  pointsButtonText: {
    color: tokens.colors.$black,
  },
});
